import AppHeader from "@app/layout/AppHeader";
import { PAGE_BG } from "@app/theme/tokens";
import { Alert, Box, Snackbar } from "@mui/material";
import { setBackendErrorHandler } from "@shared/api/client";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import NavRail from "./NavRail";

export default function DashboardShell() {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    setBackendErrorHandler(setErrorMessage);
    return () => setBackendErrorHandler(null);
  }, []);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <AppHeader />
      <Box sx={{ display: "flex", flexGrow: 1, minHeight: 0 }}>
        <NavRail />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            overflow: "auto",
            p: 3,
            background: `radial-gradient(1100px 520px at 100% -8%, rgba(0,157,224,0.12), transparent 62%), radial-gradient(900px 480px at -10% 110%, rgba(0,42,92,0.08), transparent 60%), ${PAGE_BG}`,
          }}
        >
          <Outlet />
        </Box>
      </Box>

      <Snackbar
        open={!!errorMessage}
        autoHideDuration={8000}
        onClose={() => setErrorMessage(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="error" onClose={() => setErrorMessage(null)}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}
